import { render, staticRenderFns } from "./ConsumeDetails.vue?vue&type=template&id=2ca04c89"
import script from "./ConsumeDetails.vue?vue&type=script&lang=js"
export * from "./ConsumeDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsumeDetails.vue?vue&type=style&index=0&id=2ca04c89&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports